interface MedioDeclaracion {
  id: number
  value: string
}

const mediosDeclaracion: MedioDeclaracion[] = [
    { value: "A-ORDINARIO", id: 7 },
    { value: "A-REPARACION DIFERIDA", id: 13 },
    { value: "A-REPARACION PROPIA", id: 9 },
    { value: "A-URGENTE", id: 6 },
    { value: "B.FAX", id: 10 },
    { value: "COMUNICACION CIA CONTRARIA", id: 12 },
    { value: "COMUNICACION DE PERJUDICADO", id: 11 },
    { value: "CORRESPONDENCIA ORDINARIA", id: 8 },
    { value: "E-MAIL", id: 5 },
    { value: "FAX", id: 4 },
    { value: "PRESENCIA EN OFICINA", id: 2 },
    { value: "SE IGNORA", id: 1 },
    { value: "SINIESTRO RESERVA", id: 14 },
    { value: "TELEFONICAMENTE", id: 3 }
]

export default mediosDeclaracion